import { useAccountCompanyId } from 'application/hooks';

import { useBillingCompanyBillingInfoQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';

interface UseChangePricePlanPeriodConfirmModalViewModel {
  renewableLicensesLength: number;
  hasTrialLicenses: boolean;
  formatNextBillingDate: string;
  loading: boolean;
  hasInactiveLicenses: boolean;
}

const useChangePricePlanPeriodConfirmModalViewModel = (): UseChangePricePlanPeriodConfirmModalViewModel => {
  const companyId = useAccountCompanyId();

  const { data, loading } = useBillingCompanyBillingInfoQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
    variables: { companyId },
  });

  const renewableLicenses = data?.result?.renewableLicenses || [];
  const hasTrialLicenses = Boolean(data?.result?.hasTrialLicenses);
  const hasInactiveLicenses = Boolean(data?.result?.hasInactiveLicenses);
  const formatNextBillingDate = DateUtils.getFormatDateFrom(new Date(data?.result?.nextBillingDate), 'dd MMMM yyyy');

  return {
    renewableLicensesLength: renewableLicenses.length,
    hasTrialLicenses,
    formatNextBillingDate,
    loading,
    hasInactiveLicenses,
  };
};

export default useChangePricePlanPeriodConfirmModalViewModel;
